import { ConfigurationMapper } from './configuration';
import { toSelectorValue } from './email-document';
import { EmailDocumentDefault } from '../../../models';
import { EmailDocumentDefault as OctopusEmailDocumentDefault } from '../models';

export class EmailDocumentDefaultMapper extends ConfigurationMapper<
  OctopusEmailDocumentDefault,
  EmailDocumentDefault
> {
  from(source: OctopusEmailDocumentDefault): EmailDocumentDefault {
    return {
      id: source.Key ?? '',
      result: toSelectorValue(source.Result),
      category: toSelectorValue(source.Category),
      readAccess: source.SecAccess?.Read[0].Key.Uid ?? '',
      fullAccess: source.SecAccess?.Write[0].Key.Uid ?? '',
    };
  }
}
